<template>
  <el-dialog :visible.sync="dialogFormVisible" :title="titles[updateType]" :before-close="close" :close-on-click-modal="false">
    <el-form ref="form" label-width="140px" :model="initForm" :rules="rules">
      <el-form-item label="设备机型型号" prop="name">
        <el-input v-model="initForm.name" placeholder="请输入设备机型型号"></el-input>
      </el-form-item>

      <el-form-item label="固件版本前缀" prop="firmware_version_field1">
        <el-input v-model="initForm.firmware_version_field1" placeholder="请输入固件版本前缀, 两段如 563.30 或三段如 563.30.15(用于区分安卓12/14等细分机型)"></el-input>
      </el-form-item>

      <el-form-item label="最新正式版本" prop="latest_stable_firmware">
        <el-input v-model="initForm.latest_stable_firmware" placeholder="请输入最新正式版本"></el-input>
      </el-form-item>

      <el-form-item label="最新Beta版本" prop="latest_beta_firmware">
        <el-input v-model="initForm.latest_beta_firmware" placeholder="请输入最新Beta版本"></el-input>
      </el-form-item>

      <el-form-item label="最新LTS版本" prop="latest_lts_firmware">
        <el-input v-model="initForm.latest_lts_firmware" placeholder="请输入最新LTS版本"></el-input>
      </el-form-item>

      <el-form-item label="请选择设备类型" prop="device_type">
        <el-select v-model="initForm.device_type" placeholder="请选择设备类型">
        <el-option
          v-for="device_type in deviceTypesList"
          :label="device_type"
          :key="device_type"
          :value="device_type"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="备注" prop="desc">
        <el-input v-model="initForm.desc" placeholder="备注"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button @click="$emit('close')" type="info">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    initForm: {},
    updateType: {},
    deviceTypesList: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      rules: {
        name: [{required: true, message: "请输入设备机型型号", trigger: "blur"}],
        firmware_version_field1: [{required: true, message: "请输入固件版本前缀(两段或三段)", trigger: "blur"}],
        device_type: [{required: true, message: "请选择设备类型", trigger: "blur"}],
        desc: [{required: false, message: "请填写备注信息", trigger: "blur"}]
      },
      titles: {
        add: "新增",
        edit: "编辑"
      }
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
    onSubmit() {
      this.$refs.form.validate(valid => {
        var method = "";
        var url = "";
        var msg = "操作失败";
        var formData = {
              name: this.initForm.name,
              firmware_version_field1: this.initForm.firmware_version_field1,
              latest_stable_firmware: this.initForm.latest_stable_firmware,
              latest_beta_firmware: this.initForm.latest_beta_firmware,
              latest_lts_firmware: this.initForm.latest_lts_firmware,
              device_type: this.initForm.device_type,
              desc: this.initForm.desc
            };
        if (!valid) {alert("请检查输入是否正确！"); return false;};
        this.dialogFormVisible = false;
        if (this.updateType === "add") {
          method = "post";
          url = "device-info/models/";
          msg = "添加成功";
        } else if (this.updateType === "edit") {
          method = "patch";
          url = "device-info/models/" + this.initForm.id + "/";
          msg = "编辑成功";
        } else{
          return false;
        };
        this.$http[method](
          url,
          formData,
          () => {
            this.$baseNotice.message(msg);
            this.$emit("close");
            this.$emit("update");
          }
        )
      });
    }
  }
};
</script>
